module.exports = __webpack_public_path__ + "static/media/Ex3-S4.98b1c886.PNG";